module.exports = __webpack_public_path__ + "static/media/library_book_hunt.5e48d705.pdf";